import { render, staticRenderFns } from "./Ecoterra.vue?vue&type=template&id=2e82d575&scoped=true&"
import script from "./Ecoterra.vue?vue&type=script&lang=js&"
export * from "./Ecoterra.vue?vue&type=script&lang=js&"
import style0 from "./Ecoterra.vue?vue&type=style&index=0&id=2e82d575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82d575",
  null
  
)

export default component.exports